<template>
  <div class="cart-item">
    <a :href="model.url" class="thumb" target="_blank">
      <media :media="media" width="192" />
    </a>
    <div class="info">
      <div class="name" v-text="model.name" />
      <p>
        Количество: {{ product.quantity }}<br>
        Цвет: {{ model.color.name }}<br>
        Размер: {{ size }}
      </p>
      <div class="prices">
        <div :class="['price price-rub', { discount: isDiscount }]">
          {{ price.discountPrice || price.basePrice | price }}
        </div>
        <div
          v-if="isDiscount"
          class="old-price"
        >
          {{ price.basePrice | price }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'cart-item',
  props: {
    product: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    model() {
      return this.product.models?.[0] || {};
    },
    media() {
      return this.model.media?.[0] || {};
    },
    size() {
      return this.model.skus?.find(sku => sku.id === this.product.skuId)?.size;
    },
    price() {
      return this.model.price || {};
    },
    isDiscount() {
      return Number(this.model.price?.discountRate);
    },
  },
}
</script>

<style lang="scss">
.cart-item {
  display: flex;
  padding: 12px;
  &:not(:last-of-type) {
    box-shadow: inset 0 -1px 0 $gray_lu;
  }
  .thumb {
    flex: 0 0 96px;
    height: 132px;
    background: $gray_lu;
    margin-right: 12px;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  .info {
    flex: 1;
    display: flex;
    flex-direction: column;
  }
  .name {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    margin-bottom: 4px;
  }
  p {
    font-size: 12px;
    line-height: 20px;
    color: $gray;
  }
  .prices {
    margin-top: auto;
    display: flex;

    .price {
      font-weight: 600;
      font-size: 16px;
      line-height: 20px;
      display: flex;
      &.discount {
        color: $red;
      }
    }

    .old-price {
      color: $gray;
      margin-left: 8px;
      font-weight: normal;
      font-size: 12px;
      text-decoration: line-through;
    }
  }
}
</style>
